var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vue-content-loading",
    { staticClass: "py-3", attrs: { width: 800, height: 450 } },
    [
      _c("rect", {
        attrs: { x: "0", y: "0", rx: "3", ry: "3", width: "70", height: "10" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "80", y: "0", rx: "3", ry: "3", width: "100", height: "10" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "190", y: "0", rx: "3", ry: "3", width: "10", height: "10" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "20", rx: "3", ry: "3", width: "130", height: "10" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "155",
          y: "20",
          rx: "3",
          ry: "3",
          width: "130",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "40", rx: "3", ry: "3", width: "90", height: "10" }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "115",
          y: "40",
          rx: "3",
          ry: "3",
          width: "60",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: {
          x: "185",
          y: "40",
          rx: "3",
          ry: "3",
          width: "60",
          height: "10"
        }
      }),
      _vm._v(" "),
      _c("rect", {
        attrs: { x: "0", y: "60", rx: "3", ry: "3", width: "30", height: "10" }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05a90028", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05a90028","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentLoader.vue
// module id = null
// module chunks = 